import React, { useEffect, useState } from "react";
import { handlePrioridadeSCColumn }  from "../GridCell/Solicitacao";
import ResponsiveDataTable from "../DataTable";
import { converteDataProtheus, formatDateColumn } from "../../contents/VariaveisGlobais";
import { Row, Col } from "react-bootstrap";
import { handleProdutoCPColumn, handleSaldoCPColumn, handleArmazemCP } from "../GridCell/ContratoParceria";
import SelectFornecedor from "../Select/Fornecedor";
import InputGeral from "../InputGeral/Index";
import SelectFinalidade from "../Select/Finalidade";
import SelectFixo from "../SelectFixo";
import SelectComprador from "../Select/Comprador";
import SelectCondicaoPagamento from "../Select/CondicaoPagamento";
import TrelloBoard from "../TrelloBoard";

const SelecaoItemContratoParceria = (DisparaBootBox, FecharBox, dataCP, setDataCP, FecharBoxDefault) => {
    const handleChangeObsFornecedor = ( item, data, setData ) => {
		const newData = data.map( (itemProduto) => {
            itemProduto.OBSERVACAO = item.OBSERVACAO
        })

        setData(newData)
    } 
    
    const { EMPRESA, C3_FILIAL, C3_NUM, C3_DATPRI, C3_DATPRF, C3_FORNECE, C3_LOJA, C3_USER, C3_TPFRETE, C3_XFLUXCP, C3_XTIPCOM, C3_COND, Y1_COD, Y1_NOME, A2_NOME, A2_CGC, DHK_DESCR, E4_DESCRI } = dataCP[0]
    const empresaFilial = EMPRESA + '' + C3_FILIAL;
    const columns = [
        { Header: 'Produto/Serviço',       accessor: "C3_PRODUTO",   Cell: handleProdutoCPColumn },
        { Header: 'Qtde. / Preço',         accessor: 'C3_QUANT',     Cell: (item) => handleSaldoCPColumn(item, dataCP, setDataCP) },
        { Header: 'Armazém / CC / Conta',  accessor: 'LOCAL',        Cell: (item) => handleArmazemCP(item, dataCP, setDataCP, empresaFilial) }
    ];

    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];
    const prioridadeOption = options.filter( (option) => option.value === (C3_XFLUXCP.trim() || "1"))
    const tipoFreteOption = C3_TPFRETE === 'C' ? 'CIF' : C3_TPFRETE === 'F' ? 'FOB' : ''
    const dataIni = converteDataProtheus(C3_DATPRI);
    const dataFim = converteDataProtheus(C3_DATPRF);
    const Comprador = {value: C3_USER, label: Y1_COD + ' - ' + Y1_NOME}
    const Fornecedor = {value: C3_FORNECE + '' + C3_LOJA, label: C3_FORNECE + '/' + C3_LOJA + ' - ' + A2_NOME.trim() + '(' + A2_CGC.trim() + ')'}
    const TipoFrete = {value: C3_TPFRETE, text: tipoFreteOption}
    const Prioridade = {value: (C3_XFLUXCP.trim() || "1"), text: prioridadeOption[0].text }
    const Finalidade = {value: C3_XTIPCOM, label: C3_XTIPCOM + " - " + DHK_DESCR} 
    const CondicaoPagamento = {value: C3_COND, label: C3_COND + ' - ' + E4_DESCRI}
    
    const Mensagem = (
        <>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Numero CP"
                        placeholder="Numero CP"
                        tipo="text"
                        value={C3_NUM}
                        disabled={true}
                    />
                </Col>
                <Col md="6" xs="12">
                    <SelectFornecedor
                        campoFornecedor={Fornecedor}
                        empresaLogada={empresaFilial}
                        returnOriginal={true}
                        disabled={true}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Data Inicio"
                        placeholder="Data Inicio"
                        tipo="date"
                        value={dataIni}
                        disabled={true}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Data Fim"
                        placeholder="Data Fim"
                        tipo="date"
                        value={dataFim}                        
                        disabled={true}
                    />
                </Col>

                <Col md="3" xs="12">
                    <SelectComprador
                        campoComprador={Comprador}
                        empresaLogada={empresaFilial}
                        disabled={true}
                    />
                </Col>
                <Col md="2" xs="12">
                    <SelectFinalidade
                        campoFinalidade={Finalidade}
                        empresaLogada={empresaFilial}
                        returnOriginal={true}
                        filtraFilial={true}
                        showNoFilter={true}
                        disabled={true}
                    />
                </Col>
                <Col md="2" xs="12">
                    <SelectFixo
                        options={options} 
                        value={Prioridade} 
                        selectedOptionValue={Prioridade} 
                        isLabel={true} 
                        label="Prioridade" 
                        disabled={true}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectCondicaoPagamento
                        campoCondPagto={CondicaoPagamento}
                        empresaLogada={empresaFilial}
                        disabled={true}
                    />
                </Col>
                <Col md="2" xs="12">
                    <SelectFixo 
                        options={[{
                            value: 'C',
                            text: "CIF",
                        },
                        {
                            value: 'F',
                            text: "FOB",
                        }]}
                        isLabel={true} 
                        label="Tipo Frete"
                        selectedOptionValue={TipoFrete}
                        value={TipoFrete}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable
                        data={dataCP} // Carregar dados conforme necessário
                        columns={columns}
                        buttons={[]}
                        isIgnorar={true}
                        habilitaCheckBox={true}
                        condicionalCheck="data[rowIndex].CC?.label?.trim() && data[rowIndex].LOCAL?.label?.trim() && data[rowIndex].CONTA?.label?.trim() && parseFloat(data[rowIndex].QTDSEL) > 0" //So deixa selecionar se tiver sido preenchido Quantidade Local/CC/Conta
                    />
                </Col>
            </Row>
            <Row>
                <Col md="12" xs="12">
                    <InputGeral
                        label="Observação Fornecedor"
                        placeholder="Observação Fornecedor"
                        tipo="textArea"
                        bindItem={dataCP[0]}
                        field={"OBSERVACAO"}
                        onChange={(e) => { handleChangeObsFornecedor(dataCP[0], dataCP, setDataCP) }}
                    />
                </Col>
            </Row>
        </>
    );

    const buttonsRender = [
        { variant: 'primary', action: FecharBox, label: 'Aplicar' }
    ];

    DisparaBootBox('Selecione o(s) Item(ns) do Contrato de Parceria', Mensagem, buttonsRender, 0, FecharBoxDefault, 'xl', false);
};



export default SelecaoItemContratoParceria;